import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { css, useTheme, jsx } from '@emotion/react';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useMemo } from 'react';
import _typeof from '@babel/runtime/helpers/esm/typeof';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52;
function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    console.warn('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysSpaceSm = tokens.sysSpaceSm,
      sysSpaceMd = tokens.sysSpaceMd,
      sysSpaceXl = tokens.sysSpaceXl,
      sysSpaceJumbo = tokens.sysSpaceJumbo,
      sysSizeMediaSm = tokens.sysSizeMediaSm,
      sysSizeMediaMd = tokens.sysSizeMediaMd,
      sysSizeMediaLg = tokens.sysSizeMediaLg,
      sysSizeMediaXl = tokens.sysSizeMediaXl,
      sysSizeMediaXxl = tokens.sysSizeMediaXxl;
  var vxContainerPaddingMD = '2.25rem';
  var sysSpaceXl4 = '3rem';
  var breakpointMap = {
    sm: sysSizeMediaSm,
    md: sysSizeMediaMd,
    lg: sysSizeMediaLg,
    xl: sysSizeMediaXl,
    xxl: sysSizeMediaXxl
  };
  var commonColumn = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    min-height: 1px;\n    padding-right: ", ";\n    padding-left: ", ";\n  "])), sysSpaceMd, sysSpaceMd);

  var commonColumnForm = function () {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "])), sysSpaceSm, sysSpaceSm);
  };

  var colGridCalculator = function (n, breakpoint) {
    var space = n / 12 * 100;
    var labelStr = "col".concat(breakpoint ? '_' + breakpoint : '', "_").concat(n);
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      label: ", ";\n      -ms-flex: 0 0 ", "%;\n      flex: 0 0 ", "%;\n      max-width: ", "%;\n    "])), labelStr, space, space, space);
  };
  /* istanbul ignore next */


  var colGridBreakpoint = function (n) {
    var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sm';
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      ", ";\n      @media (min-width: ", ") {\n        ", "\n      }\n    "])), commonColumn, breakpointMap[breakpoint], colGridCalculator(n, breakpoint));
  };
  /* istanbul ignore next */


  var order = function (num, breakpoint) {
    var labelStr = "order".concat(breakpoint ? '_' + breakpoint : '', "_").concat(num);
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      label: ", ";\n      -ms-flex-order: ", ";\n      order: ", ";\n    "])), labelStr, num, num);
  };
  /* istanbul ignore next */


  var orderBreakpoint = function (n) {
    var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sm';
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      @media (min-width: ", ") {\n        ", "\n      }\n    "])), breakpointMap[breakpoint], order(n, breakpoint));
  };

  var offset = function (num, breakpoint) {
    var labelStr = "offset".concat(breakpoint ? '_' + breakpoint : '', "_").concat(num);
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      label: ", ";\n      margin-left: ", "%;\n    "])), labelStr, num / 12 * 100);
  };
  /* istanbul ignore next */


  var offsetBreakpoint = function (n) {
    var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sm';
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      @media (min-width: ", ") {\n        ", ";\n      }\n    "])), breakpointMap[breakpoint], offset(n, breakpoint));
  };
  /* istanbul ignore next */


  /* istanbul ignore next */
  var dynamicCol = function (breakpoint, n) {
    if (breakpoint && n) {
      return colGridBreakpoint(n, breakpoint);
    } else if (n && (breakpoint === undefined || breakpoint === '')) {
      return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        ", ";\n        ", "\n      "])), commonColumn, colGridCalculator(n));
    }

    return '';
  };
  /* istanbul ignore next */


  var display = function (_display, breakpoint) {
    var labelStr = "display".concat(breakpoint ? '_' + breakpoint : '', "_").concat(_display);
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      label: ", ";\n      display: ", ";\n    "])), labelStr, _display);
  };

  var displayBreakpoint = function (breakpoint, _display) {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      @media (min-width: ", ") {\n        ", "\n      }\n    "])), breakpointMap[breakpoint], display(_display, breakpoint));
  };

  var container = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    label: grid_container;\n    width: 100%;\n    padding-right: ", ";\n    padding-left: ", ";\n    margin-right: auto;\n    margin-left: auto;\n\n    @media (min-width: ", ") {\n      padding-right: ", ";\n      padding-left: ", ";\n      max-width: ", ";\n    }\n\n    @media (min-width: ", ") {\n      padding-right: ", ";\n      padding-left: ", ";\n      max-width: ", ";\n    }\n\n    @media (min-width: ", ") {\n      padding-right: ", ";\n      padding-left: ", ";\n      max-width: ", ";\n    }\n\n    @media (min-width: ", ") {\n      padding-right: ", ";\n      padding-left: ", ";\n      max-width: ", ";\n    }\n  "])), sysSpaceMd, sysSpaceMd, sysSizeMediaSm, sysSpaceXl, sysSpaceXl, sysSizeMediaSm, sysSizeMediaMd, vxContainerPaddingMD, vxContainerPaddingMD, sysSizeMediaMd, sysSizeMediaLg, vxContainerPaddingMD, vxContainerPaddingMD, sysSizeMediaLg, sysSizeMediaXl, vxContainerPaddingMD, vxContainerPaddingMD, sysSizeMediaXl);
  var layoutContainer = css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    label: layout_container;\n    width: 100%;\n    padding-right: ", ";\n    padding-left: ", ";\n    margin-right: auto;\n    margin-left: auto;\n    max-width: ", ";\n\n    @media (min-width: ", ") {\n      padding-right: ", ";\n      padding-left: ", ";\n      max-width: ", ";\n    }\n\n    @media (min-width: ", ") {\n      padding-right: ", ";\n      padding-left: ", ";\n      max-width: ", ";\n    }\n  "])), vxContainerPaddingMD, vxContainerPaddingMD, sysSizeMediaXxl, sysSizeMediaMd, sysSpaceJumbo, sysSpaceJumbo, sysSizeMediaXxl, sysSizeMediaXxl, sysSpaceXl4, sysSpaceXl4, sysSizeMediaXxl);
  var row = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    label: row;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-right: -", ";\n    margin-left: -", ";\n  "])), sysSpaceMd, sysSpaceMd);
  var containerForm = css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    label: container_form;\n    width: 100%;\n    padding-right: 0;\n    padding-left: 0;\n    margin-right: auto;\n    margin-left: auto;\n  "])));
  var containerFluid = css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    label: container_fluid;\n    width: 100%;\n    padding-right: ", ";\n    padding-left: ", ";\n    margin-right: auto;\n    margin-left: auto;\n  "])), sysSpaceMd, sysSpaceMd);
  var noGutter = css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    label: no_gutter;\n    margin-right: 0;\n    margin-left: 0;\n\n    > [class*='-col-'],\n    > [class*='-col'] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  "])));
  var col = css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    label: col;\n    ", ";\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  "])), commonColumn);
  var colAuto = css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    label: col_auto;\n    ", ";\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  "])), commonColumn);
  var colFormVspace = css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    label: col_form_vspace;\n    ", "\n  "])), commonColumnForm());
  var colFormFull = css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    label: col_form_full;\n    ", ";\n    ", "\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n  "])), commonColumn, commonColumnForm(), sysSizeMediaSm);
  var colFormHalf = css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    label: col_form_half;\n    ", ";\n    ", "\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n      max-width: 50%;\n    }\n  "])), commonColumn, commonColumnForm(), sysSizeMediaSm);
  var colForm3qtr = css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    label: col_form_3_qtr;\n    ", ";\n    ", "\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 75%;\n      flex: 0 0 75%;\n      max-width: 75%;\n    }\n  "])), commonColumn, commonColumnForm(), sysSizeMediaSm);
  var colForm1qtr = css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    label: col_form_1_qtr;\n    ", ";\n    ", "\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n      max-width: 25%;\n    }\n  "])), commonColumn, commonColumnForm(), sysSizeMediaSm);
  var colFormAuto = css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    label: col_form_auto;\n    ", ";\n    ", "\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  "])), commonColumn, commonColumnForm());
  var orderFirst = css(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n    label: order_first;\n    -ms-flex-order: -1;\n    order: -1;\n  "])));
  var orderLast = css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    label: order_last;\n    -ms-flex-order: 13;\n    order: 13;\n  "])));
  var colSm = css(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n    label: col_sm;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n  "])), commonColumn, sysSizeMediaSm);
  var colSmAuto = css(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n    label: col_sm_auto;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: none;\n    }\n  "])), commonColumn, sysSizeMediaSm);
  var colMd = css(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    label: col_md;\n    @media (min-width: ", ") {\n      ", ";\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n  "])), sysSizeMediaMd, commonColumn);
  var colMdAuto = css(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n    label: col_md_auto;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: none;\n    }\n  "])), commonColumn, sysSizeMediaMd);
  var colLg = css(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n    label: col_lg;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n  "])), commonColumn, sysSizeMediaLg);
  var colLgAuto = css(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n    label: col_lg_auto;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: none;\n    }\n  "])), commonColumn, sysSizeMediaLg);
  var colXl = css(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n    label: col_xl;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n  "])), commonColumn, sysSizeMediaXl);
  var colXlAuto = css(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n    label: col_xl_auto;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: none;\n    }\n  "])), commonColumn, sysSizeMediaXl);
  var colXxl = css(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n    label: col_xxl;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n  "])), commonColumn, sysSizeMediaXxl);
  var colXxlAuto = css(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n    label: col_xxl_auto;\n    ", ";\n    @media (min-width: ", ") {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: none;\n    }\n  "])), commonColumn, sysSizeMediaXxl);
  var orderSmFirst = css(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n    label: order_sm_first;\n    @media (min-width: ", ") {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n  "])), sysSizeMediaSm);
  var orderSmLast = css(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n    label: order_sm_last;\n    @media (min-width: ", ") {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n  "])), sysSizeMediaSm);
  var orderMdFirst = css(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n    label: order_md_first;\n    @media (min-width: ", ") {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n  "])), sysSizeMediaMd);
  var orderMdLast = css(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n    label: order_md_last;\n    @media (min-width: ", ") {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n  "])), sysSizeMediaMd);
  var orderLgFirst = css(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n    label: order_lg_first;\n    @media (min-width: ", ") {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n  "])), sysSizeMediaLg);
  var orderLgLast = css(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n    label: order_lg_last;\n    @media (min-width: ", ") {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n  "])), sysSizeMediaLg);
  var orderXlFirst = css(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n    label: order_xl_first;\n    @media (min-width: ", ") {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n  "])), sysSizeMediaXl);
  var orderXlLast = css(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n    label: order_xl_last;\n    @media (min-width: ", ") {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n  "])), sysSizeMediaXl);
  var orderXxlFirst = css(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n    label: order_xxl_first;\n    @media (min-width: ", ") {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n  "])), sysSizeMediaXxl);
  var orderXxlLast = css(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n    label: order_xxl_last;\n    @media (min-width: ", ") {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n  "])), sysSizeMediaXxl);
  var justifyContentStart = css(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n    label: justify_content_start;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  "])));
  var justifyContentEnd = css(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n    label: justify_content_end;\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  "])));
  var justifyContentCenter = css(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n    label: justify_content_center;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  "])));
  var justifyContentBetween = css(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n    label: justify_content_between;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  "])));
  var justifyContentAround = css(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n    label: justify_content_around;\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  "])));
  return {
    firstLtrUprCase: function firstLtrUprCase(str) {
      return str && typeof str === 'string' ? str.charAt(0).toUpperCase() + str.slice(1) : str;
    },
    container: container,
    layoutContainer: layoutContainer,
    row: row,
    containerForm: containerForm,
    containerFluid: containerFluid,
    noGutter: noGutter,
    commonColumn: commonColumn,
    col: col,
    colAuto: colAuto,
    colFormVspace: colFormVspace,
    colFormFull: colFormFull,
    colFormHalf: colFormHalf,
    colForm3qtr: colForm3qtr,
    colForm1qtr: colForm1qtr,
    colFormAuto: colFormAuto,
    dynamicCol: dynamicCol,
    dynamicOrder: function dynamicOrder(breakpoint, n) {
      if (breakpoint && n) {
        return orderBreakpoint(n, breakpoint);
      }

      return order(n);
    },
    dynamicOffset: function dynamicOffset(breakpoint, n) {
      if (breakpoint && n) {
        return offsetBreakpoint(n, breakpoint);
      }

      return offset(n);
    },
    dynamicDisplay: function dynamicDisplay(breakpoint, _display) {
      if (breakpoint && _display) return displayBreakpoint(breakpoint, _display);
      return display(_display);
    },
    orderFirst: orderFirst,
    orderLast: orderLast,
    colSm: colSm,
    colSmAuto: colSmAuto,
    colMd: colMd,
    colMdAuto: colMdAuto,
    colLg: colLg,
    colLgAuto: colLgAuto,
    colXl: colXl,
    colXlAuto: colXlAuto,
    colXxl: colXxl,
    colXxlAuto: colXxlAuto,
    orderSmFirst: orderSmFirst,
    orderSmLast: orderSmLast,
    orderMdFirst: orderMdFirst,
    orderMdLast: orderMdLast,
    orderLgFirst: orderLgFirst,
    orderLgLast: orderLgLast,
    orderXlFirst: orderXlFirst,
    orderXlLast: orderXlLast,
    orderXxlFirst: orderXxlFirst,
    orderXxlLast: orderXxlLast,
    justifyContentStart: justifyContentStart,
    justifyContentEnd: justifyContentEnd,
    justifyContentCenter: justifyContentCenter,
    justifyContentBetween: justifyContentBetween,
    justifyContentAround: justifyContentAround
  };
}

var _excluded = ["as", "fluid", "form", "xxl", "className"];

var getClass = function (fluid, form, xxl, _styles) {
  if (form) {
    return _styles.containerForm;
  }

  if (fluid) {
    return _styles.containerFluid;
  }

  if (xxl) {
    return _styles.layoutContainer;
  }

  return _styles.container;
};

var Container = function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$fluid = _ref.fluid,
      fluid = _ref$fluid === void 0 ? false : _ref$fluid,
      _ref$form = _ref.form,
      form = _ref$form === void 0 ? false : _ref$form,
      _ref$xxl = _ref.xxl,
      xxl = _ref$xxl === void 0 ? false : _ref$xxl,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  return jsx(as, _extends({
    css: getClass(fluid, form, xxl, _styles),
    className: className,
    "data-ppui-info": "grid_3.2.9"
  }, props));
};

var _excluded$1 = ["as", "className", "form"];
var sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
var vxColClass = 'col';

var columnClasses = function (form, props, _styles) {
  var spans = [];
  var classes = [];

  if (form) {
    var _styles$firstLtrUprCa;

    var formUprCase = (_styles$firstLtrUprCa = _styles.firstLtrUprCase) === null || _styles$firstLtrUprCa === void 0 ? void 0 : _styles$firstLtrUprCa.call(_styles, form);
    classes.push(_styles["colForm".concat(formUprCase)]);
  } // Iterate through breakpoint sizes, generate classes for configured breakpoints


  sizes.forEach(function (breakpoint) {
    var propValue = props[breakpoint];
    delete props[breakpoint];
    var span, offset, order, display; // Configuration is coming in as object notation

    if (_typeof(propValue) === 'object') {
      span = propValue.span || true;
      offset = propValue.offset;
      order = propValue.order;
      display = propValue.display;
    } else {
      span = propValue;

      if (typeof propValue === 'boolean') {
        display = propValue ? 'block' : 'none';
      }
    }

    var infix = '',
        infixLwrCse = '';

    if (breakpoint !== 'xs') {
      var _styles$firstLtrUprCa2;

      infix = (_styles$firstLtrUprCa2 = _styles.firstLtrUprCase) === null || _styles$firstLtrUprCa2 === void 0 ? void 0 : _styles$firstLtrUprCa2.call(_styles, breakpoint);
      infixLwrCse = breakpoint;
    }
    /* istanbul ignore next */


    var spanCssVal = function (spanVal) {
      var _styles$dynamicCol, _styles$firstLtrUprCa3;

      if (spanVal === true) {
        return _styles["".concat(vxColClass).concat(infix)];
      }

      return typeof spanVal === 'number' ? (_styles$dynamicCol = _styles.dynamicCol) === null || _styles$dynamicCol === void 0 ? void 0 : _styles$dynamicCol.call(_styles, infixLwrCse, spanVal) : _styles["".concat(vxColClass).concat(infix).concat((_styles$firstLtrUprCa3 = _styles.firstLtrUprCase) === null || _styles$firstLtrUprCa3 === void 0 ? void 0 : _styles$firstLtrUprCa3.call(_styles, spanVal))];
    }; // Append base col classess


    if (typeof span !== 'undefined') {
      spans.push(spanCssVal(span));
    } // Append order based classes


    if (typeof order !== 'undefined') {
      var _styles$dynamicOrder;

      classes.push((_styles$dynamicOrder = _styles.dynamicOrder) === null || _styles$dynamicOrder === void 0 ? void 0 : _styles$dynamicOrder.call(_styles, infixLwrCse, order));
    } // Append offset classes


    if (typeof offset !== 'undefined') {
      var _styles$dynamicOffset;

      classes.push((_styles$dynamicOffset = _styles.dynamicOffset) === null || _styles$dynamicOffset === void 0 ? void 0 : _styles$dynamicOffset.call(_styles, infixLwrCse, offset));
    } // Append display classes


    if (typeof display !== 'undefined') {
      var _styles$dynamicDispla;

      classes.push((_styles$dynamicDispla = _styles.dynamicDisplay) === null || _styles$dynamicDispla === void 0 ? void 0 : _styles$dynamicDispla.call(_styles, infixLwrCse, display));
    }
  }); // Add in the base col class if no spans were configured

  if (!spans.length && !form) {
    spans.push(_styles["".concat(vxColClass)]);
  }

  return [].concat(spans, classes);
};

var Col = function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      form = _ref.form,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  return jsx(as, _extends({
    css: columnClasses(form, props, _styles),
    className: className
  }, props, {
    "data-ppui": "true"
  }));
};

var _excluded$2 = ["as", "className", "noGutters", "align"];

var Row = function (_ref) {
  var _styles$firstLtrUprCa;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      _ref$noGutters = _ref.noGutters,
      noGutters = _ref$noGutters === void 0 ? false : _ref$noGutters,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? null : _ref$align,
      props = _objectWithoutProperties(_ref, _excluded$2);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  /* istanbul ignore next */
  var alignUprCase = align && typeof align === 'string' ? (_styles$firstLtrUprCa = _styles.firstLtrUprCase) === null || _styles$firstLtrUprCa === void 0 ? void 0 : _styles$firstLtrUprCa.call(_styles, align) : align;
  var cssVal = [_styles.row, noGutters && _styles.noGutter, align && _styles["justifyContent".concat(alignUprCase)]];
  return jsx(as, _extends({
    css: cssVal,
    className: className,
    "data-ppui-info": "grid_3.2.9"
  }, props));
};

export { Col, Container, Row, styles as gridStyles };
